import { asyncAction, action } from 'now-frontend-shared/utils/actions';

// async actions
export const updateDocumentTemplate = asyncAction('documentTemplate/UPDATE_DOCUMENT_TEMPLATE');

// sync action
export const reset = action('documentTemplate/RESET');
